

import React, { useState, useRef, useEffect } from "react";
import "./selectbox.css";
import '../../global.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faAngleDown
} from '@fortawesome/free-solid-svg-icons';

function MultiSelectDropdown() {
  const [options] = useState([
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
    { value: "option4", label: "Option 4" },
    { value: "option5", label: "Option 5" },
    { value: "option6", label: "Option 6" },
]);

    const [selectedTags, setSelectedTags] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const dropdownRef = useRef(null);

    // Handle click outside dropdown
    useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
    }, []);

    // Add tag
    const addTag = (option) => {
        if (!selectedTags.some((tag) => tag.value === option.value)) {
        setSelectedTags([...selectedTags, option]);
        }
        setInputValue("");
        setDropdownVisible(false);
    };

    // Remove tag
    const removeTag = (value) => {
        setSelectedTags(selectedTags.filter((tag) => tag.value !== value));
    };

    // Filter dropdown options
    const filteredOptions = options.filter(
        (option) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase()) &&
            !selectedTags.some((tag) => tag.value === option.value)
    );

    return (
        <div className="form-group mt-4">
            <label className="form-label">Item 2</label>
            <div className="multi-select-container" ref={dropdownRef}>
                <div className="tags">
                    {selectedTags.map((tag) => (
                    <span className="tag" key={tag.value}>
                        {tag.label}
                        <span
                            className="remove-tag"
                            onClick={() => removeTag(tag.value)}
                        >
                            &times;
                        </span>
                    </span>
                ))}
                    <input
                        type="text"
                        className="tag-input"
                        value={inputValue}
                        onFocus={() => setDropdownVisible(true)}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="Select options"
                    />
                    <div className="select_icon">
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                </div>
                {dropdownVisible && (
                    <div className="dropdown">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                        <div
                            key={option.value}
                            className="dropdown-item"
                            onClick={() => addTag(option)}
                            >
                            {option.label}
                        </div>
                    ))
                    ) : (
                        <div className="dropdown-item">No options found</div>
                    )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default MultiSelectDropdown;
